import React from 'react';
import { inlineTokens } from '../lib/editorialText';

export default function EditorialInline({ text = '' }) {
  return inlineTokens(text).map((token, index) => {
    const children = token.type === 'code' || token.type === 'text' ? token.text : React.createElement(EditorialInline, { text: token.text });
    if (token.type === 'link') return React.createElement('a', { key: index, href: token.href }, children);
    if (['strong', 'em', 'code'].includes(token.type)) return React.createElement(token.type, { key: index }, children);
    return React.createElement(React.Fragment, { key: index }, children);
  });
}
